@if (!open) {
  <button type="button" class="assistant-fab" (click)="toggle()" aria-label="Abrir el asistente">
    <i class="pi pi-sparkles"></i>
  </button>
}

@if (open) {
  <section class="assistant-window card" aria-label="Asistente">
    <header>
      <span class="assistant-title">{{ view === 'history' ? 'Conversaciones' : 'Asistente' }}</span>

      @if (view === 'chat') {
        <button type="button" class="assistant-icon-btn" (click)="showHistory()" title="Ver conversaciones anteriores">
          <i class="pi pi-history"></i>
        </button>
      } @else {
        <button type="button" class="assistant-icon-btn" (click)="backToChat()" title="Volver a la conversación">
          <i class="pi pi-comment"></i>
        </button>
      }
      <button type="button" class="assistant-icon-btn" (click)="newConversation()" title="Empezar una conversación nueva">
        <i class="pi pi-plus"></i>
      </button>
      <button type="button" class="assistant-icon-btn" (click)="close()" title="Cerrar">
        <i class="pi pi-times"></i>
      </button>
    </header>

    @if (view === 'history') {
      <div class="assistant-history">
        @if (conversations.length === 0) {
          <p class="assistant-empty">Todavía no has hablado con el asistente.</p>
        } @else {
          @for (conversation of conversations; track conversation.id) {
            <button type="button" class="assistant-history-row" (click)="openConversation(conversation)">
              <span class="assistant-history-row-text">
                <span class="assistant-history-title">
                  @if (lastFailed(conversation)) {
                    <i class="pi pi-exclamation-triangle assistant-history-failed" title="Esta conversación terminó en un error"></i>
                  }
                  {{ conversation.title }}
                </span>
                <span class="assistant-history-meta">
                  {{ when(conversation.lastMessageAt) }} · {{ conversation.messages.length }} mensajes
                </span>
              </span>
              <i
                class="pi pi-trash assistant-history-delete"
                title="Borrar esta conversación"
                (click)="deleteConversation(conversation, $event)"
              ></i>
            </button>
          }
        }
      </div>
    }

    @if (view === 'chat') {
      <div class="assistant-messages" #thread>
        @if (currentMessages.length === 0) {
          <div class="assistant-welcome">
            <p>Pregúntame cómo se usa el panel.</p>
            <ul>
              <li>«¿cómo reservo un puesto?»</li>
              <li>«¿dónde apruebo una solicitud?»</li>
              <li>«¿cómo edito la Guía del trabajador?»</li>
            </ul>
          </div>
        }
        @for (message of currentMessages; track $index) {
          <div class="assistant-message" [class.assistant-message-user]="message.role === 'user'">
            <div class="assistant-bubble" [class.assistant-bubble-error]="message.error">{{ message.text }}</div>
          </div>
        }
        @if (sending) {
          <div class="assistant-message">
            <div class="assistant-bubble assistant-bubble-typing">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
          </div>
        }
      </div>

      <div class="flex gap-2 assistant-input-row">
        <textarea
          #field
          pTextarea
          class="flex-1"
          rows="1"
          placeholder="Escribe tu pregunta..."
          [(ngModel)]="question"
          (keydown)="onKeydown($event)"
          [disabled]="sending"
        ></textarea>
        <button pButton type="button" icon="pi pi-send" [disabled]="sending || !question.trim()" (click)="send()"></button>
      </div>
    }
  </section>
}
